var ns;
ns.App.factory('StockTransitionsService', function($http, API_ENDPOINT, HttpFactory, DsFactory, Utils){
  return {
    searchStTransitions: function(params){
      var endpoint = API_ENDPOINT + '/st_transition_headers/search';
      if(!angular.isUndefined(params)){
        endpoint += "?" + Utils.getQueryStr(params);
      }
      return HttpFactory.createGet(endpoint);
    },

    invoiceExportAction: function(params){
      var endpoint = API_ENDPOINT + '/units/invoice_export_action';
      return HttpFactory.createPost(endpoint, params);
    },

    IfInvoiceController: function(params){
      var endpoint = API_ENDPOINT + '/units/invoice_export_data';
      return HttpFactory.createPost(endpoint, params);
    },

    getInvoice: function(sid, dsConf, params){
      var endpoint = API_ENDPOINT + '/units/editable?screen_id=' + sid;
      if(!angular.isUndefined(params)){
        endpoint += "&" + Utils.getQueryStr(params);
      }
      return DsFactory.create(dsConf, endpoint);
    },
    getInvoiceMonths: function(sid, dsConf, params){
      var endpoint = API_ENDPOINT + '/units_month?screen_id=' + sid;
      return DsFactory.create(dsConf, endpoint);
    },

    getInvoiceMonthIos: function(sid, dsConf, params){
      var endpoint = API_ENDPOINT + '/units_month_ios?screen_id=' + sid;
      endpoint += "&" + Utils.getQueryStr(params);
      return DsFactory.create(dsConf, endpoint);
    },
    getInvoiceMonthStocks: function(sid, dsConf, params){
      var endpoint = API_ENDPOINT + '/units_month_stocks?screen_id=' + sid;
      endpoint += "&" + Utils.getQueryStr(params);
      return DsFactory.create(dsConf, endpoint);
    },
    getInvoiceMonthInvoices: function(sid, dsConf, params){
      var endpoint = API_ENDPOINT + '/units_month_invoices?screen_id=' + sid;
      endpoint += "&" + Utils.getQueryStr(params);
      return DsFactory.create(dsConf, endpoint);
    },

    //締処理
    unitProcedureMonthsFix: function(params){
      var endpoint = API_ENDPOINT + '/units_month/fix';
      return HttpFactory.createPost(endpoint, params);
    },
    //締めデータ編集
    unitProcedureMonthsEdit: function(params){
      var endpoint = API_ENDPOINT + '/units_month/edit';
      return HttpFactory.createPost(endpoint, params);
    },
    editInvoice: function(sid, dsConf, params){
      var endpoint = API_ENDPOINT + '/units/editinvoice?screen_id=' + sid;
      if(!angular.isUndefined(params)){
        endpoint += "&" + Utils.getQueryStr(params);
      }
      return DsFactory.create(dsConf, endpoint);
    },

    editInvoices: function(sid, params){
      var endpoint = API_ENDPOINT + '/units/editinvoice?screen_id=' + sid;
      if(!angular.isUndefined(params)){
        endpoint += "&" + Utils.getQueryStr(params);
      }
      return HttpFactory.createGet(endpoint);
    },
    //登録
    storeInvoices: function(params){
      var endpoint = API_ENDPOINT + '/units/editinvoice';
      return HttpFactory.createPost(endpoint, params);
    },
    //更新
    updateInvoices: function(params, id){
      var endpoint = API_ENDPOINT + '/units/editinvoice/' + id;
      return HttpFactory.createPut(endpoint, params);
    },
    //削除
    deleteInvoices: function(id){
      var endpoint = API_ENDPOINT + '/units/editinvoice/' + id;
      return HttpFactory.createDelete(endpoint);
    }

  };
});

